module.exports = __webpack_public_path__ + "static/img/X驾驶监控系统.e8f0b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3-model/X驾驶监控系统.png
// module id = G0+h
// module chunks = 0